import React from "react"
import styled from "styled-components"
import { breakpoint } from "../../../configs/utilities"
import line from "../../../assets/config/line.svg"
const HorizontalLine = () => {
  return (
    <LineWrapper>
      <img src={line} alt="silver line" />
    </LineWrapper>
  )
}

export default HorizontalLine

const LineWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 50px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    padding: 0 100px;
  }

  img {
    width: 100%;
  }
`
